import { Api } from 'models/services/api';
import { ReadFranchiseesQuery } from 'models/services/graphql';

import { FranchiseeCollectionData } from '../collection';

type DataToFetch = {
  organizationId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadFranchisees($organizationId: ID!, $nextToken: String) {
    ${ReadFranchiseesQuery}
  }
`;

type ResponseData = {
  data: {
    readFranchisees: FranchiseeCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: FranchiseeCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readFranchisees;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
